
const AccessDenied = ({ botId }) => {
    return (
        <div className="access-denied-container">
            <div className="content">
                <img src={"https://storage.googleapis.com/seek-logos/ibexco-assests/access-denied.svg"} alt="Access Denied" />
                <h1 className="title">Access Denied</h1>
                <p className="message">You do not have permission to access this bot.</p>
            </div>
        </div>
    );
};

export default AccessDenied;
